import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_arrow_top",
  "use": "icon-icon_general_arrow_top-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_arrow_top\">\n<g>\n\t<polygon points=\"38.2000008,33.7999992 24,19.5 9.8000002,33.7999992 6.1999998,30.2000008 24,12.5\n\t\t41.7999992,30.2000008 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol